var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "xl",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n                Close Modal\n            ")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.close_modal },
                  },
                  [_vm._v("\n                    Закрити\n                ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.save_doc },
                  },
                  [_vm._v("\n                    Зберегти\n                ")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_users_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _c("span", { staticClass: "fw-300" }, [
                  _vm._v("ID:" + _vm._s(this.doc.id)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.is_load
            ? _c(
                "div",
                { staticClass: "p-4" },
                [
                  _c("div", { staticClass: "form-group mt-2" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "advanced_name" },
                      },
                      [
                        _vm._v(
                          "\n                        ID\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group flex-nowrap" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.doc.id,
                            expression: "doc.id",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "advanced_name",
                          disabled: "",
                          type: "text",
                        },
                        domProps: { value: _vm.doc.id },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.doc, "id", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mt-2" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "advanced_name" },
                      },
                      [
                        _vm._v(
                          "\n                        Назва\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group flex-nowrap" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.doc.name,
                            expression: "doc.name",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "advanced_name",
                          disabled: "",
                          type: "text",
                        },
                        domProps: { value: _vm.doc.name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.doc, "name", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mt-2" }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "advanced_name" },
                      },
                      [
                        _vm._v(
                          "\n                        Ради *\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-table", {
                    staticClass: "table-responsive-xl resolution_table",
                    attrs: {
                      "head-variant": "dark",
                      "thead-class": "dark",
                      busy: _vm.is_load,
                      striped: "",
                      items: _vm.doc.attached_radu,
                      fields: _vm.fields,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(name)",
                          fn: function (data) {
                            return [
                              parseInt(data.item.id) > 0
                                ? _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(data.item.name) +
                                        "\n                                "
                                    ),
                                    _c("div", { staticClass: "small" }, [
                                      _vm._v(
                                        "\n                                    Кількість паїв :"
                                      ),
                                      _c("small", [
                                        _vm._v(
                                          "   " +
                                            _vm._s(data.item.attached_pai_count)
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: data.item.name,
                                          expression: "data.item.name",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        id: "advanced_name",
                                        type: "text",
                                      },
                                      domProps: { value: data.item.name },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            data.item,
                                            "name",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "cell(remove)",
                          fn: function (data) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "remove_new_item text-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove_item(
                                        data.item,
                                        data.index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fal fa-trash-alt fs-xl cursor-pointer color-danger-100",
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(id)",
                          fn: function (data) {
                            return [
                              parseInt(data.item.id) > 0
                                ? _c("div", { staticClass: "id_cc" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(data.item.id) +
                                        "\n                            "
                                    ),
                                  ])
                                : _c("div", [
                                    _c("span", { staticClass: "badge" }, [
                                      _vm._v(
                                        "\n                                    new\n                                "
                                      ),
                                    ]),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1666608509
                    ),
                  }),
                  _vm._v(" "),
                  _c("table", { staticClass: "mt-3" }, [
                    _c("tfoot", [
                      _c("tr", [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "btn btn-outline-warning waves-effect waves-themed",
                              attrs: { id: "add_rada", title: "" },
                              on: { click: _vm.new_rada },
                            },
                            [_vm._v("Додати")]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }